import { TimesheetStatusEnum } from "domain/enum/timesheetStatus";
import { ExpenseStatusEnum } from "domain/enum/expenseStatus";
import { InvoiceStatusEnum } from "domain/enum/invoiceStatus";
import { VacationStatusEnum } from "domain/enum/vacationStatus";
import { SupportTripStatusEnum } from "domain/enum/supportTripStatus";
import { TripsheetStatusEnum } from "domain/enum/tripsheetStatus";

// Color language shared by every status badge in the mobile app
export type StatusTone = "pending" | "progress" | "done" | "rejected" | "neutral";

export interface StatusStyle {
    color: string;
    bg: string;
    border: string;
}

export const STATUS_TONE_STYLES: Record<StatusTone, StatusStyle> = {
    pending: { color: "#D97706", bg: "#FFFBEB", border: "#FDE68A" }, // someone still has to act
    progress: { color: "#0084D1", bg: "#EFF6FF", border: "#BFDBFE" }, // in progress / not final
    done: { color: "#059669", bg: "#ECFDF5", border: "#A7F3D0" }, // completed
    rejected: { color: "#DC2626", bg: "#FEF2F2", border: "#FECACA" }, // rejected / lost
    neutral: { color: "#64748B", bg: "#F1F5F9", border: "#E2E8F0" }, // cancelled / inactive / unknown
};

type StatusTones = Record<string, StatusTone>;

export const TIMESHEET_STATUS_TONES: StatusTones = {
    [TimesheetStatusEnum.NOVO]: "pending",
    [TimesheetStatusEnum.EDITADO]: "pending",
    [TimesheetStatusEnum.ENVIADO]: "progress",
    [TimesheetStatusEnum.CANCELADO]: "neutral",
};

export const EXPENSE_STATUS_TONES: StatusTones = {
    [ExpenseStatusEnum.PENDENTE]: "pending",
    [ExpenseStatusEnum.APROVADO]: "progress",
    [ExpenseStatusEnum.PAGO]: "done",
    [ExpenseStatusEnum.NAO_APROVADO]: "rejected",
};

export const INVOICE_STATUS_TONES: StatusTones = {
    [InvoiceStatusEnum.ENVIADO]: "pending",
    [InvoiceStatusEnum.APROVADO]: "done",
    [InvoiceStatusEnum.NAO_APROVADO]: "rejected",
};

export const VACATION_STATUS_TONES: StatusTones = {
    [VacationStatusEnum.A_APROVAR]: "pending",
    [VacationStatusEnum.APROVADO]: "done",
    [VacationStatusEnum.NAO_APROVADO]: "rejected",
    [VacationStatusEnum.CANCELAMENTO_PENDENTE]: "progress",
    [VacationStatusEnum.CANCELADO]: "neutral",
};

export const SUPPORT_TRIP_STATUS_TONES: StatusTones = {
    [SupportTripStatusEnum.A_APROVAR]: "pending",
    [SupportTripStatusEnum.APROVADO]: "done",
    [SupportTripStatusEnum.NAO_APROVADO]: "rejected",
    [SupportTripStatusEnum.CANCELAMENTO_PENDENTE]: "progress",
    [SupportTripStatusEnum.CANCELADO]: "neutral",
};

export const TRIPSHEET_STATUS_TONES: StatusTones = {
    [TripsheetStatusEnum.ASSINADO_1]: "pending",
    [TripsheetStatusEnum.ASSINADO_2]: "done",
};

// Equipment statuses come from the backend as codes
export const EQUIPMENT_STATUS_TONES: StatusTones = {
    IN_USE: "done",
    IN_MAINTENANCE: "pending",
    IN_STOCK: "progress",
    LOST: "rejected",
    OBSOLETE: "neutral",
};

// Unknown or missing statuses fall back to neutral (gray)
export const getStatusStyle = (tones: StatusTones, status?: string): StatusStyle =>
    STATUS_TONE_STYLES[(status && tones[status]) || "neutral"];
